import {LinkButton} from '@primer/react'
import {CommentIcon} from '@primer/octicons-react'
import type {PullRequestReviewInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {useLayoutRouteData} from '../../../../page-data/loaders/use-layout-route-data'
import {Link} from '@github-ui/react-router'
import {routeToReviewSummary} from '../../../overview/data/use-comments-routing'

export function PullRequestReviewAction({info}: {info: PullRequestReviewInfo}) {
  const {pullRequest, repository} = useLayoutRouteData()
  const {reviewId, commentCount} = info

  if (!commentCount || !reviewId) {
    return null
  }
  return (
    <LinkButton
      as={Link}
      to={routeToReviewSummary(
        {
          owner: repository.ownerLogin,
          repo: repository.name,
          pr_number: pullRequest.number.toString(),
        },
        reviewId.toString(),
      )}
      size="small"
      variant="invisible"
      aria-label={`View ${commentCount} review ${commentCount === 1 ? 'comment' : 'comments'}`}
      leadingVisual={CommentIcon}
      className="flex-items-center"
    >
      {commentCount}
    </LinkButton>
  )
}
